import { DataTableBodyCellDate, DataTableBodyCellGender, TableCellRowLine } from '@/components/custom';
import DataTableBodyCellAccountStatus from './DataTableBodyCellAccountStatus';
import DataTableBodyCellUsername from './DataTableBodyCellUsername';
import DataTableBodyCellCountry from './DataTableBodyCellCountry';
import DataTableBodyCellOptions from './DataTableBodyCellOptions';
import DataTableBodyCellCoins from './DataTableBodyCellCoins';
import DataTableBodyCellEmail from './DataTableBodyCellEmail';
import DataTableBodyCellAge from './DataTableBodyCellAge';
import { TableBody, TableRow } from '@/components/ui';
import { useNavigate } from 'react-router-dom';
import { useUsers } from '../../hooks';
import routes from '@/lib/routes';

export const DataTableBody = () => {

  const navigate = useNavigate();
  const { users } = useUsers();

  return (
    <TableBody>
      {
        [...users]
          .map(
            (item, index) => (
              <TableRow
                key={item._id}
                onClick={() => navigate(routes.nav.users.single.getHref(item._id))}
                className='cursor-pointer'>
                <TableCellRowLine value={index + 1} />
                <DataTableBodyCellAccountStatus user={item} />
                <DataTableBodyCellCountry user={item} />
                <DataTableBodyCellGender gender={item.gender} />
                <DataTableBodyCellAge user={item} />
                <DataTableBodyCellUsername user={item} />
                <DataTableBodyCellEmail user={item} />
                <DataTableBodyCellCoins user={item} />
                <DataTableBodyCellDate date={item.createdAt} />
                <DataTableBodyCellOptions user={item} />
              </TableRow>
            )
          )
      }
    </TableBody>
  );

};

export default DataTableBody;
